import type {RumTimeMark} from '../types'
import {getRumGlobal, getRumPage, GLOBAL_OBJ, parseRumPageVar} from '../utils'

type RumGlobal = NonNullable<ReturnType<typeof getRumGlobal>>

const wordLike = (i: string) => new RegExp('^[a-z-_]+$').test(i)

const finalizeRumCounterMetrics = (rum: RumGlobal) => {
  rum.sendTrafficData()
  rum.finalizeLayoutShiftScore()
  rum.finalizeLargestContentfulPaint()
  rum.finalizeINP?.()

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((rum as any)._tti?.fired === false) {
    rum.sendTTI?.(undefined, rum.getTime())
  }
}

// @ts-expect-error Принудительно делаем RUM-метрики непривязанными
const disconnectTrencher = (rum: Partial<RumGlobal>) => rum.setVars?.({rum_id: undefined})

const updateRumPage = (rum: Partial<RumGlobal>) => {
  const currPage = getRumPage()
  const [, prevPath] = parseRumPageVar()
  const nextPath = GLOBAL_OBJ.location?.pathname.substring(1).split('/').filter(Boolean)[1] || 'index'

  if (prevPath && prevPath !== nextPath) {
    const nextPage = currPage!.replace(new RegExp(`.${prevPath}$`), `.${wordLike(nextPath) ? nextPath : 'unknown'}`)

    rum.setVars?.({'-page': nextPage})
    rum.updateErrors?.({page: nextPage})
  }
}

export const sendRumTimeMark = (name: RumTimeMark) => getRumGlobal()?.sendTimeMark?.(name)

export const finalizeRumCounter = () => {
  const rum = getRumGlobal()

  if (rum) {
    const [serviceName] = parseRumPageVar()

    finalizeRumCounterMetrics(rum)

    if (serviceName === 'account') {
      updateRumPage(rum)
      rum.resetINP?.()
    }

    setTimeout(() => disconnectTrencher(rum))
  }
}
